import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, submit } from 'redux-form'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import Button from 'material-ui/Button'

import { SimpleTextField } from './group'
import { setStage, disable } from 'modules/users/otp'

const Form = ({ handleSubmit }) => (
  <form className="disable-submit-event" onSubmit={handleSubmit}>
    <fieldset>
      <Field
        component={SimpleTextField}
        label="Enter password"
        name="password"
        type="password"
        id="input-disable2fa-password"
        required
        autoComplete="off"
        className="form-control-mui"
      />
    </fieldset>
  </form>
)

const Disable2FA = ({ setStage, submit, open }) => (
  <Dialog open={open} onClose={() => setStage('')}>
    <DialogTitle>Disable 2-Step Verification</DialogTitle>
    <DialogContent>
      <p>Enter your password for disable 2-Step Verification</p>
      <ReduxForm />
    </DialogContent>
    <Divider light />
    <DialogActions>
      <Button onClick={() => setStage('')}>Close</Button>
      <Button id="btn-disable2fa-confirm" onClick={() => submit('profile_edit_disable2fa')}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.users.otp.stage === 'disable2fa'
})

const mapDispatchToProps = dispatch => bindActionCreators({ setStage, disable, submit }, dispatch)

const ReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'profile_edit_disable2fa',
    onSubmit: ({ password }, dispatch, { disable }) => disable({ password })
  })(Form)
)

export default connect(mapStateToProps, mapDispatchToProps)(Disable2FA)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/disable2fa.js